import { action } from "../../../utils/actions";

export const GET_EIDSR_INTEGRATION = action("GET_EIDSR_INTEGRATION");
export const EDIT_EIDSR_INTEGRATION = action("EDIT_EIDSR_INTEGRATION");

export const GET_EIDSR_ORGANISATION_UNITS = action(
  "GET_EIDSR_ORGANISATION_UNITS",
);
export const GET_EIDSR_PROGRAM = action("GET_EIDSR_PROGRAM");
